import { useEffect, useRef, useState } from "react"
import "./notifyToggle.css"
import "./notifyToggleDark.css"
import { useDispatch, useSelector } from "react-redux";
import DrawerTaskNotiify from "../../page/taskManager/drawerTaskNotidy/drawerTaskNotidy";

import axios from "axios";
import OverdueTasks from "../../page/taskManager/overdueTasks/overdueTasks";
import CreatNotifyTask from "../../page/taskManager/creatTaskNotify/creatTaskNotify";
import CommentNotify from "../../page/taskManager/commentNotify/commentNotify";
import notifySong from "./notifySong.wav"
import GlobalNotify from "../../page/taskManager/globalNotify/globalNotify";
import sockets from "../../../socket/socket";

const socket = sockets;
export default function NotifyToggle(params) {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const getDarkModoe = useSelector(darkModes => darkModes)
  const [room, setRoom] = useState('');
  const [message, setMessage] = useState('');
  const [receivedMessages, setReceivedMessages] = useState([])
  const [delLoad, setDelload] = useState(false)
  const [load, setload] = useState(false)
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [perfomerID, setperfomerID] = useState([]);
  const [mynotify, setmynotify] = useState([]);
  const [deleteNotifyLoading, setdeleteNotifyLoading] = useState(false)

  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
  let getCompanyID = useSelector(compID => compID.checkedSessionReducer)
  let getmyinfo = useSelector(compID => compID.getMayInfoReducer)
  const audioRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {

    if (!dropdownRef.current.contains(event.target)) {

      setIsOpen(false);
    }
  };

  useEffect(() => {

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  useEffect(() => {
    socket.emit('pushmyid', getmyinfo.myinfo._id);
    socket.on('newMessage', (message) => {

      setload(true)


      axios.get('/getTaskfinded/api', {

      })
        .then(function (response) {

          setReceivedMessages(response.data.data);
          setload(false)
        })
        .catch(function (error) {
          console.log(error);
          setload(false)
        })
        .finally(function () {
          // always executed
        });

    });
    // update all task for my data
    socket.on('getAllTaskANDupdate', () => {

      setload(true)


      axios.get('/getAllTaskANDupdate/api', {

      })
        .then(function (response) {

          setReceivedMessages(response.data.data);
          setload(false)
        })
        .catch(function (error) {
          console.log(error);
          setload(false)
        })
        .finally(function () {
          // always executed
        });

    });

    socket.on('getNotify', (msg) => {
      setload(true)
      axios({
        method: 'get',
        url: '/notifyConfirm',

      })
        .then(function (response) {
          setload(false)
          setmynotify(response.data.data)
          // playSound()

        });
    });


    return () => {
      socket.off('newMessage');
      socket.off('disconnect');
      socket.off('notification');
      socket.off('getNotify');
      socket.off('getAllTaskANDupdate');

    };
  }, []);

  const playSound = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };


  // update compID
  useEffect(() => {

    setReceivedMessages([])
    // socket.emit('joinRoom', getCompanyID.checkedSession);
    socket.emit('getAllTask', { companyIDS: getCompanyID.checkedSession });
    socket.emit('getNotifyEmit');
  }, [])
  // =====



  function update(params) {
    socket.emit('message', { room: getCompanyID.checkedSession });
  }
  const handleGetNotify = () => {
    socket.emit('getNotifyEmit');
  }

  async function deleteAllNotify() {
    setdeleteNotifyLoading(true)
    if (mynotify.length > 0) {
      let notifyID = [];
      mynotify.forEach(not => {

        notifyID.push(not._id)
      });
      axios.post('/deletAllNotification/api', {
        notifyID
      })
        .then(function (response) {
          console.log(response);
          setdeleteNotifyLoading(false)
          socket.emit('getNotifyEmit');
        })
        .catch(function (error) {
          console.log(error);
          setdeleteNotifyLoading(false)
        });
    }


  }



  return (
    <div ref={dropdownRef} className={getDarkModoe.ToggleDarkModeReducer.chekced ? "dropdownAllNotifyContDark" : "dropdownAllNotifyCont"}>


      {/* <button className="dropdown-toggle" onClick={toggleDropdown}>
          Toggle Dropdown
        </button> */}
      {/* notify for pc */}
      <div className="notifyBtnNav" onClick={toggleDropdown}>


      {
  mynotify.length > 0 ? (
    <div className="badge">
      {mynotify.length >= 999 ? (
        <p>999+</p>
      ) : (
        <p>{mynotify.length}</p>
      )}
    </div>
  ) : null
}


       
        <button>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <path d="M13.8658 8.65134C14.3605 13.2213 16.3027 14.6024 16.3027 14.6024H1C1 14.6024 3.55045 12.7888 3.55045 6.44095C3.55045 4.99792 4.08786 3.614 5.04446 2.59362C6.00107 1.57324 7.2985 1 8.65134 1C8.93809 1 9.22238 1.02576 9.50149 1.07608" stroke="#353535" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.6022 6.10089C16.0108 6.10089 17.1527 4.95902 17.1527 3.55045C17.1527 2.14188 16.0108 1 14.6022 1C13.1936 1 12.0518 2.14188 12.0518 3.55045C12.0518 4.95902 13.1936 6.10089 14.6022 6.10089Z" stroke="#353535" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.1222 17.1523C9.97272 17.41 9.75823 17.6239 9.50004 17.7725C9.24193 17.9212 8.94931 17.9995 8.65142 17.9995C8.35353 17.9995 8.06091 17.9212 7.8028 17.7725C7.5447 17.6239 7.33012 17.41 7.18066 17.1523" stroke="#353535" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      {/* notify for mobile */}
      {/* <div className="notifyBtnNavForMobile" onClick={toggleDropdown}>
          
        {
          mynotify.length ?
            <span className="StatusNotify">{mynotify.length}</span>
            :
            ""
        }
        <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.5865 24.5C15.6865 24.5 16.5865 23.6 16.5865 22.5H12.5865C12.5865 23.6 13.4765 24.5 14.5865 24.5ZM20.5865 18.5V13.5C20.5865 10.43 18.9465 7.86 16.0865 7.18V6.5C16.0865 5.67 15.4165 5 14.5865 5C13.7565 5 13.0865 5.67 13.0865 6.5V7.18C10.2165 7.86 8.58648 10.42 8.58648 13.5V18.5L7.29648 19.79C6.66648 20.42 7.10648 21.5 7.99648 21.5H21.1665C22.0565 21.5 22.5065 20.42 21.8765 19.79L20.5865 18.5Z"
              fill="#C3CAD9"
            />
          </svg>
        </button>
      </div> */}
      {isOpen && (
        <div className="dropdown-menuNotify">
          {
            (() => {
              if (deleteNotifyLoading) {
                return <div class="custom-loaderDeletNotify"></div>

              } else {
                if (mynotify.length > 0) {
                  return <button className="deleteAllNotify" onClick={deleteAllNotify}> Удалить все уведомления<span class="material-symbols-outlined">clear_all</span> </button>
                }

              }
            })()
          }

          <div className="dropdown-menuNotifyCont">
            <span class="tooltiptext"></span>
            <audio ref={audioRef} src={notifySong} />
            {
              (() => {

                if (load) {
                  return <h1 style={{ textAlign: 'center' }}>Загрузка</h1>
                }
                if (mynotify.length <= 0) {
                  return <h1 style={{ textAlign: 'center' }}>Нет уведомлений</h1>
                }
              })()
            }





            {
              mynotify?.map((item, index) => {

                console.log(item, "itemNotify");
                if (item.typenotifyGlobal === "taskConfirm") {
                  return <DrawerTaskNotiify mynotify={mynotify} lengthNotify={mynotify?.length.toString()} update={update} handleGetNotify={handleGetNotify} item={item} index={index} />
                } else if (item.typenotifyGlobal == "overdueTasks") {
                  return <OverdueTasks item={item} />
                }
                else if (item.typenotifyGlobal == "creatTaskNotifyInfo") {
                  return <CreatNotifyTask item={item} />
                }
                else if (item.typenotifyGlobal == "creatCommentNotify") {
                  return <CommentNotify item={item} />
                }
                else if (item.typenotifyGlobal == "globalNotifyiInfoTask") {
                  return <GlobalNotify item={item} />
                }

              })
            }
          </div>

        </div>
      )}
    </div>)
}